function findExtractionStep(configuration) {
  const steps = configuration?.steps;
  if (!Array.isArray(steps)) return null;
  const step = steps.find((s) => s?.type === 'document_processor' && s?.config?.document_extraction?.[0]);
  if (!step) return null;
  return step.config.document_extraction[0];
}

export function extractFields(configuration) {
  const extraction = findExtractionStep(configuration);
  const modelOutput = extraction?.model_output;
  if (!modelOutput) return [];
  const requiredFields = modelOutput.required_fields || [];
  const descriptions = modelOutput.descriptions || {};
  return requiredFields.map((name) => ({ name, description: descriptions[name] || '' }));
}

export function buildTemplateConfiguration(documentType) {
  return {
    name: 'formIQ_document_processor_pipeline',
    description: 'FormIQ Document Processor pipeline',
    id: 'form_iq_document123',
    data: { object_url: ['some_s3_presigned_url'] },
    steps: [
      {
        type: 'job_processor',
        config: { input_field: ['job_id', 'config_id'], output_field: 'file_urls', process_type: 'FETCH' },
      },
      {
        type: 'document_processor',
        config: {
          input_field: ['documents'],
          output_field: 'document_extractions',
          model: {
            deployment_type: 'VLLM',
            model_url: 'http://vllm.msg-semanticbridge.svc.cluster.local:8000/v1',
            model_id: 'Qwen/Qwen3-32B-AWQ',
            prompt: 'Extract the relevant information from the following text: {text}',
          },
          document_extraction: [
            {
              document_type: documentType,
              use_ocr: false,
              model_output: { name: 'FormIQExtractor', format_instructions: '', required_fields: [], descriptions: {} },
            },
          ],
        },
      },
      {
        type: 'job_processor',
        config: {
          process_type: 'UPDATE',
          input_field: ['job_id', 'config_id', 'document_extractions'],
          output_field: 'update_response',
        },
      },
      {
        type: 'output_processor',
        config: { url: '', input_field: 'update_response', output_field: 'saved_output', output_format: 'WEBHOOK' },
      },
    ],
  };
}

export function applyFields(configuration, fields) {
  const updated = JSON.parse(JSON.stringify(configuration));
  const extraction = findExtractionStep(updated);
  if (!extraction) return updated;
  extraction.model_output = extraction.model_output || {};
  extraction.model_output.required_fields = fields.map((f) => f.name);
  extraction.model_output.descriptions = Object.fromEntries(fields.map((f) => [f.name, f.description]));
  return updated;
}
